// Nav type
export type navLinkType = {
  label: string;
  url: string;
};

// Nav
const navLinks = [
  {
    label: 'Services',
    url: '#services',
  },
  {
    label: 'Projects',
    url: '#works',
  },
  {
    label: 'About',
    url: '#about-me-section',
  },
  {
    label: 'Testimonials',
    url: '#testimonials-section',
  },
  {
    label: 'Contact',
    url: '#contact-section',
  },
];
const navbarLinks = [
  {
    label: 'Home',
    url: '#app',
  },
  ...navLinks,
];

const socialLinks = [
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/ajten-cani/',
  },
  {
    label: 'GitHub',
    url: 'https://github.com/ajten-cani',
  },
  {
    label: 'X',
    url: 'https://x.com/ajten_cani',
  },
];

const resourceLinks = [
  {
    label: 'Vue.js',
    url: 'https://vuejs.org/',
  },
  {
    label: 'Laravel',
    url: 'https://laravel.com/',
  },
];

const heroText =
  'A web developer crafting modern digital experiences, turning ideas into clean, animated, and scalable products.';

const locationPlace = `41°19'39"N 19°49'07"E`;
const locationCountry = 'Albania, Tirana';

export {
  socialLinks,
  resourceLinks,
  heroText,
  locationPlace,
  locationCountry,
  navLinks,
  navbarLinks,
};
